import React from "react";
import {useMutation, useQueryClient} from "react-query";

import ConfirmButton from "../../../../commonComponents/confirmButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash, faUndo} from "@fortawesome/free-solid-svg-icons";
import {useLoggedInApi} from "../../../../api";
import {toast} from "react-toastify";

export default function ToggleStatusButton({lotId, isActive}) {
    const queryClient = useQueryClient();
    const apiClient = useLoggedInApi();

    const mutationAction = () => {
        const resource = apiClient.resource('payment/lots');
        if (isActive) {
            return resource.deleteItem(lotId);
        } else {
            return resource.postItemAction(lotId, 'enable', {});
        }
    }

    const mutation = useMutation({
        mutationFn: () => {
            const mutationPromise = mutationAction();
            toast.promise(mutationPromise, {
                pending: isActive ? "Deleting lot..." : "Enabling lot...",
                success: isActive ? "Lot deleted successfully" : "Lot enabled successfully",
                error: isActive ? "Failed to delete lot" : "Failed to enable lot"
            })
            return mutationPromise
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['payment', 'lots']);
            queryClient.invalidateQueries(['table', 'payment/lots']);
        },
        onError: (error) => {
            console.error("Error toggling lot status:", error);
        }
    });

    return (
        <ConfirmButton
            className={`btn btn-sm btn-${isActive ? 'danger' : 'success'} outline px-1`}
            style={{
                width: "5em"
            }}
            color={isActive ? 'danger' : 'success'}
            confirmText={<>
                <FontAwesomeIcon
                    color="white"

                    icon={isActive ? faTrash : faUndo} /> Sure?
            </>}
            onClick={() => mutation.mutate()}
            isLoading={mutation.isLoading}
        >
            <FontAwesomeIcon
                color={"white"}
                icon={isActive ? faTrash : faUndo} />
        </ConfirmButton>
    );
}